/**
 * What is in every engagement.
 *
 * The lead does the work here: "Not upsells. These are the terms we work
 * under, written into the contract." Six short guarantees, deliberately plain,
 * because each one is answering a fear somebody has been burned by before —
 * losing the code, a surprise invoice, an unreachable developer.
 */
import { Section } from '../components/Section';
import { useI18n } from '../i18n';
import styles from './Standards.module.css';

export function Standards() {
  const { t } = useI18n();

  return (
    <Section eyebrow={t.standards.eyebrow} title={t.standards.title} lead={t.standards.lead}>
      <div className={`grid ${styles.grid}`}>
        {t.standards.items.map((item) => (
          <article key={item.title} className="cell">
            <h3 className={styles.title}>
              <span className={styles.tick} aria-hidden="true" />
              {item.title}
            </h3>
            <p className={styles.body}>{item.body}</p>
          </article>
        ))}
      </div>
    </Section>
  );
}
